export const urlSearchParams = {
  CARRIER: 'carrier',
  COUNTRY: 'country',
  DES: 'des',
  FROM: 'from',
  LOGO: 'logo',
  RESTRICTED: 'restricted',
  TEXT: 'text',
  TO: 'to',
} as const;
